// Homepage-only public display metadata. Customer order data remains live.
// Bangkok status changes are managed separately; no automatic date logic here.
export const homepageTrips = [
  {
    "name": "BANGKOK OKTOBER 2026",
    "country": "THAILAND",
    "status": "OPEN",
    "start_date": "2026-10-22",
    "end_date": "2026-11-04",
    "estimate": "20 November – 5 Desember 2026"
  },
  {
    "name": "CHINA SEPTEMBER 2026",
    "country": "CHINA",
    "status": "CLOSED",
    "start_date": "",
    "end_date": "",
    "estimate": "16–30 November 2026"
  }
];
